import React from 'react';
import { routePaths } from '../../routePaths';
import { EditScreenLayout } from '../../ui-kit';
import { CreateCustomPaymentMethodForm } from '../../modules';

const CreateCustomPaymentMethod = () => (
    <EditScreenLayout path={routePaths.customPaymentMethodsSettings}>
        <CreateCustomPaymentMethodForm />
    </EditScreenLayout>
);

export default CreateCustomPaymentMethod;
